import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  RCIPInspectionRequestVM,
  RCIPInspectionWizardVM,
} from '../../../../data/models/coverage-validator-api-models';
import {
  AddressComponent,
  ButtonComponent,
  CardComponent,
  CardRowComponent,
  IconComponent,
} from '../../../../ui-common';
import { businessTypeName, formatAddressLines, formatMailingLines } from '../../../../util-helpers';
import { payrollLabel, percentText, splitStatement, yesNo } from '../rcip-wizard.helpers';

@Component({
  selector: 'app-rcip-confirmation',
  templateUrl: './rcip-confirmation.html',
  styleUrl: './rcip-confirmation.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CurrencyPipe,
    MatCheckboxModule,
    AddressComponent,
    ButtonComponent,
    CardComponent,
    CardRowComponent,
    IconComponent,
  ],
})
export class RcipConfirmation {
  request = input.required<RCIPInspectionRequestVM>();
  answers = input.required<RCIPInspectionRequestVM>();
  wizard = input.required<RCIPInspectionWizardVM>();
  legacy = input.required<boolean>();
  submit = output<void>();

  protected readonly yesNo = yesNo;
  protected readonly percentText = percentText;
  protected payrollLabel = computed(() => payrollLabel(this.legacy()));
  protected everythingCorrect = signal(false);
  // Gates Accept & Submit only; not stored.
  protected responsesConfirmedTrue = signal(false);

  protected contactName = computed(() =>
    [this.request().contact?.firstName, this.request().contact?.lastName].filter(Boolean).join(' '),
  );
  protected business = computed(() => this.answers().insuredBusinessInformation);
  protected businessType = computed(() => businessTypeName(this.business()?.businessType));
  protected primaryLines = computed(() => formatAddressLines(this.business()?.primaryAddress));
  protected mailingLines = computed(() => formatMailingLines(this.business()));

  protected eligibilityTitles = computed(() =>
    (this.request().eligibilityStatements?.programStatementSections ?? []).map(
      (s) => splitStatement(s.statement).title,
    ),
  );


  // Deselecting Correct unchecks the confirmation, so it has to be checked again.
  protected toggleCorrect(): void {
    this.everythingCorrect.update((correct) => !correct);
    if (!this.everythingCorrect()) this.responsesConfirmedTrue.set(false);
  }
}
